module.exports = __webpack_public_path__ + "img/Sulphur Dioxide.bd5262db.svg";